import {
  selectLocationId,
  selectOrganizationId,
} from '@app/state/selectors/appSelectors';
import { AppThunk } from '@app/state/store';
import {
  actionCreatorsEmployees,
  IEmployeeDetailsScreenFilters,
  IEmployeeShiftSorting,
  IEmployeesScreenFilters,
  IEmployeesScreenSorting,
  TAddEmployeeShift,
  TEditEmployeeShift,
  TEmployeeDetailsScreenAmountsResponse,
  TEmployeeDetailsScreenShift,
  TEmployeeShiftId,
  TEmployeesMainScreenRow,
} from '@westondev/tableturn-core';

export const fetchEmployeesWeb = (
  filters: IEmployeesScreenFilters,
  sorting: IEmployeesScreenSorting,
  page: number,
  currentEmployees: TEmployeesMainScreenRow[],
  append = true,
  omitLoading = false,
): AppThunk<
  Promise<{
    success: boolean;
    totalPages: number;
    total: number;
    currentPage: number;
    employees: TEmployeesMainScreenRow[];
  }>
> => {
  return (dispatch, getState) => {
    const state = getState();
    const organizationId = selectOrganizationId(state);
    const locationId = selectLocationId(state);
    return dispatch(
      actionCreatorsEmployees.fetchEmployeesCore(
        organizationId,
        locationId,
        null,
        filters,
        sorting,
        page,
        currentEmployees,
        append,
        omitLoading,
      ),
    );
  };
};

export const fetchEmployeeDetailsShiftsWeb = (
  filters: IEmployeeDetailsScreenFilters,
  sorting: IEmployeeShiftSorting,
  page: number,
  userId: number,
  currentShifts: TEmployeeDetailsScreenShift[],
  append = true,
  omitLoading = false,
): AppThunk<
  Promise<{
    success: boolean;
    totalPages: number;
    total: number;
    currentPage: number;
    shifts: TEmployeeDetailsScreenShift[];
  }>
> => {
  return (dispatch, getState) => {
    const state = getState();
    const organizationId = selectOrganizationId(state);
    const locationId = selectLocationId(state);
    return dispatch(
      actionCreatorsEmployees.fetchEmployeeDetailsShiftsCore(
        organizationId,
        locationId,
        null,
        filters,
        sorting,
        page,
        userId,
        currentShifts,
        append,
        omitLoading,
      ),
    );
  };
};

export const fetchEmployeeDetailsSummaryWeb = (
  filters: IEmployeeDetailsScreenFilters,
  userId: number,
): AppThunk<
  Promise<
    TEmployeeDetailsScreenAmountsResponse & {
      success: boolean;
    }
  >
> => {
  return (dispatch, getState) => {
    const state = getState();
    const organizationId = selectOrganizationId(state);
    const locationId = selectLocationId(state);
    return dispatch(
      actionCreatorsEmployees.fetchEmployeeDetailsSummaryCore(
        organizationId,
        locationId,
        null,
        filters,
        userId,
      ),
    );
  };
};

export const addEmployeeShiftWeb = (
  shift: TAddEmployeeShift,
): AppThunk<Promise<boolean>> => {
  return (dispatch, getState) => {
    const state = getState();
    const organizationId = selectOrganizationId(state);
    const locationId = selectLocationId(state);
    return dispatch(
      actionCreatorsEmployees.addEmployeeShiftCore(
        organizationId,
        locationId,
        null,
        shift,
      ),
    );
  };
};

export const editEmployeeShiftWeb = (
  shift: TEditEmployeeShift,
): AppThunk<Promise<boolean>> => {
  return (dispatch, getState) => {
    const state = getState();
    const organizationId = selectOrganizationId(state);
    const locationId = selectLocationId(state);
    return dispatch(
      actionCreatorsEmployees.editEmployeeShiftCore(
        organizationId,
        locationId,
        null,
        shift,
      ),
    );
  };
};

export const deleteEmployeeShiftWeb = (
  shift: TEmployeeShiftId,
): AppThunk<Promise<boolean>> => {
  return (dispatch, getState) => {
    const state = getState();
    const organizationId = selectOrganizationId(state);
    const locationId = selectLocationId(state);
    return dispatch(
      actionCreatorsEmployees.deleteEmployeeShiftCore(
        organizationId,
        locationId,
        null,
        shift,
      ),
    );
  };
};
